import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { setIsAuthenticated, setUserInfo } from '../../store';
import { toast } from 'react-toastify';
import { resetAnalysisState } from '../../store';
import "./login.css"


const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);


  const validate = () => {
    const newErrors = {};
    if (!email) newErrors.email = 'Email is required';
    if (!password) newErrors.password = 'Password is required';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setLoading(true);
    try {
      dispatch(resetAnalysisState())
      const response = await axios.post(process.env.REACT_APP_LOGIN, {
        email,
        password,
      });

      const { accessToken, userData } = response.data;
      localStorage.setItem('token', accessToken);
      localStorage.setItem('userInfo', JSON.stringify(userData));
      dispatch(setIsAuthenticated(true));
      dispatch(setUserInfo(userData))
      navigate('/');
    } catch (error) {
      const message = error.response?.data?.message || error.response?.data?.detail.message || 'Login failed';
      toast.error(message, {
        position: "top-right",
        autoClose: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="gradient-bg min-h-screen flex items-center justify-center p-4">
      <div className="login-container rounded-2xl shadow-2xl overflow-hidden w-full max-w-md">
        <div className="p-8 sm:p-10">
          {/* Logo and Header */}
          <div className="text-center mb-8">
            <div className="flex justify-center mb-4">
              <div className="">
                {/* <i className="fas fa-chart-line text-indigo-600 text-4xl"></i> */}
                <img src="/rebato.png" width={70} />
              </div>
            </div>
            <h1 className="text-2xl font-bold text-white mb-1">Rebato</h1>
            <p className="text-indigo-100">Webgarh Solutions</p>
          </div>

          {/* Login Form */}
          <form onSubmit={handleLogin} className="space-y-6">
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-indigo-100 mb-1">Email Address</label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <i className="fas fa-envelope text-indigo-300"></i>
                </div>
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  className="input-field pl-10 block w-full rounded-lg border-0 py-3 text-gray-900 shadow-sm ring-1 ring-inset ring-indigo-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-white sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div>
              <label htmlFor="password" className="block text-sm font-medium text-indigo-100 mb-1">Password</label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <i className="fas fa-lock text-indigo-300"></i>
                </div>
                <input
                  id="password"
                  name="password"
                  type={showPassword ? 'text' : 'password'}
                  autoComplete="current-password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  className="input-field pl-10 block w-full rounded-lg border-0 py-3 text-gray-900 shadow-sm ring-1 ring-inset ring-indigo-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-white sm:text-sm sm:leading-6"
                />
                <div
                  className="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <i className={`fas ${showPassword ? 'fa-eye' : 'fa-eye-slash'} text-indigo-300 hover:text-indigo-200`}></i>
                </div>
              </div>
            </div>

            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <input
                  id="remember-me"
                  name="remember-me"
                  type="checkbox"
                  className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                />
                <label htmlFor="remember-me" className="ml-2 block text-sm text-indigo-100">Remember me</label>
              </div>
              {/* <div className="text-sm">
                <a href="#" className="font-medium text-white hover:text-indigo-200">Forgot password?</a>
              </div> */}
            </div>

            <div>
              <button
                type="submit"
                className="btn-hover transition-all flex w-full justify-center rounded-lg bg-white px-3 py-3 text-sm font-semibold leading-6 text-indigo-600 shadow-sm hover:bg-indigo-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Sign in
              </button>
            </div>
          </form>

          <div className="mt-6">
            <div className="relative">
              {/* <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-indigo-300"></div>
              </div> */}
              {/* <div className="relative flex justify-center text-sm">
                <span className="bg-indigo-600 px-2 text-indigo-100">Or continue with</span>
              </div> */}
            </div>

            {/* <div className="mt-6 grid grid-cols-2 gap-4">
              <a href="#" className="flex w-full items-center justify-center gap-3 rounded-lg bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                <i className="fab fa-google text-red-500"></i>
                <span>Google</span>
              </a>

              <a href="#" className="flex w-full items-center justify-center gap-3 rounded-lg bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                <i className="fab fa-microsoft text-blue-500"></i>
                <span>Microsoft</span>
              </a>
            </div> */}
          </div>

          <p className="mt-8 text-center text-sm text-indigo-100">
          © 2025 Webgarh Solutions. All analytics reserved.
            {/* <a href="#" className="font-semibold text-white hover:text-indigo-200">Contact administrator</a> */}
          </p>
        </div>
      </div>
    </div>
    </>
  );
};

export default LoginPage;

{/* <div><h1 className="text-3xl font-bold text-indigo-700 mb-6 text-center">
    Webgarh Solutions Order Analysis Tool
  </h1></div> */}